<template lang="html">
  <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-8">
    <div class="flex flex-col gap-1">
      <div class="text-4xl font-bold">
        {{ headline.rating }}
      </div>
      <RatingStars :value="headline.stars" size="md" />
      <div class="text-sm text-muted">
        {{ headline.countLabel }}
      </div>
    </div>

    <ul class="flex flex-1 flex-col gap-1" aria-label="Распределение оценок">
      <li v-for="row in rows" :key="row.star" class="flex items-center gap-2 text-sm">
        <span class="w-3">{{ row.star }}</span>
        <div class="h-2 flex-1 bg-elevated">
          <div class="h-2 bg-primary" :style="{ width: `${row.percent}%` }" />
        </div>
        <span class="w-8 text-right text-muted">{{ row.count }}</span>
      </li>
    </ul>

    <UButton label="Оставить отзыв" @click="emit('write')" />
  </div>
</template>

<script setup lang="ts">
import type { ShowcaseReviewSummaryDto } from '@repo/api/web/models'

import RatingStars from './RatingStars.vue'
import { distributionRows, summaryHeadline } from '../utils/reviewsFormat'

const props = defineProps<{ summary: ShowcaseReviewSummaryDto }>()
const emit = defineEmits<{ write: [] }>()

const headline = computed(() => summaryHeadline(props.summary))
const rows = computed(() => distributionRows(props.summary.distribution))
</script>
